import React, { useState } from "react";
import { Layout, Dropdown, Avatar } from "antd";
import {
  SettingOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
import "./style.css";
import logo from "../assets/InteliquantLogo.png";
// import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../Store/authSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;

const HeaderBar = ({ onToggleSidebar }) => {
  const [open, setOpen] = useState(false);

  // const { instance } = useMsal();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ✅ USER FROM REDUX
  const user = useSelector((state) => state.auth.user);

  // console.log("Header User:", user);

  const handleLogout = async () => {
    // CONFIRMATION ALERT
    const result = await Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    // LOADING ALERT
    Swal.fire({
      title: "Logging out...",
      text: "Please wait while we securely logout your session.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,

      didOpen: () => {
        Swal.showLoading();
      },
    });

    // try {
    //   // BACKEND LOGOUT
    //   await dispatch(logoutUser()).unwrap();

    //   // CLEAR STORAGE
    //   sessionStorage.clear();
    //   localStorage.clear();

    //   // CLEAR MSAL CACHE
    //   // await instance.clearCache();
    //   await instance.logoutRedirect({
    //     account: instance.getActiveAccount(),
    //     postLogoutRedirectUri: `${window.location.origin}/login`,
    //   });

    //   // SUCCESS ALERT
    //   await Swal.fire({
    //     icon: "success",
    //     title: "Logged Out",
    //     text: "You have been logged out successfully.",
    //     timer: 1200,
    //     showConfirmButton: false,
    //   });

    //   // REDIRECT
    //   navigate("/login", { replace: true });
    // }
    try {
  await dispatch(logoutUser()).unwrap();

  sessionStorage.clear();
  localStorage.clear();

  await Swal.fire({
    icon: "success",
    title: "Logged Out",
    text: "You have been logged out successfully.",
    timer: 1200,
    showConfirmButton: false,
  });

  navigate("/login", {
    replace: true,
  });
} catch (error) {
  sessionStorage.clear();
  localStorage.clear();

    await Swal.fire({
        icon: "error",
        title: "Logout Failed",
        text: "Something went wrong while logging out.",
        confirmButtonColor: "#3085d6",
      });


  navigate("/login", {
    replace: true,
  });
}
}

  const menuItems = [
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: handleLogout,
    },
  ];

  return (
    <Header className="fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-4 md:px-6 h-16 shadow-md header-main">
      {/* LEFT */}
      <div className="flex items-center gap-3">
        <button
          onClick={onToggleSidebar}
          className="lg:hidden text-white text-xl"
        >
          ☰
        </button>

        <img src={logo} alt="logo" className="h-8 md:h-9 object-contain" />
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-3 md:gap-4">
        <Dropdown
          menu={{ items: menuItems }}
          placement="bottomRight"
          open={open}
          onOpenChange={setOpen}
        >
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <Avatar icon={<UserOutlined />} />

            <div className="hidden md:flex flex-col leading-tight">
              <span className="text-white text-sm font-semibold">
                {user?.UserName || "User"}
              </span>

              <span className="text-white text-xs opacity-70">
                {user?.RoleName || "Role"}
              </span>
            </div>

            <SettingOutlined className="text-white text-sm" />
          </motion.div>
        </Dropdown>
      </div>
    </Header>
  );
};

export default HeaderBar;
